import React from 'react';
import { Instagram, ExternalLink } from 'lucide-react';

const ImageGallery = () => {
  return (
    <section className="py-12 sm:py-20 bg-gray-800">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Follow Us on <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-pink-500">Instagram</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto mb-8">
            Check out our latest creations, behind-the-scenes moments, and daily specials.
            Follow us for mouthwatering updates!
          </p>

          {/* Instagram Link */}
          <a
            href="https://instagram.com/hotslicepizzasea"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 hover:from-purple-700 hover:via-pink-700 hover:to-orange-600 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-pink-500/25"
          >
            <Instagram className="h-5 w-5" />
            <span>@hotslicepizzasea</span>
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>

        {/* Instagram Feed Grid (Static Alternative to Lightwidget) */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-1 sm:gap-2">
          {[
            '/HotSlicePizza_BuffaloChickenPizza.jpg',
            '/HotSlicePizza_MeatLoverPizza.jpg',
            '/HotSlicePizza_NYCheesecake.jpg',
            '/HotSlicePizza_GarlicCheeseBread.jpg',
            '/HotSlicePizza_Gelato.jpg',
            '/HotSlicePizza_ChickenPestoPizza.jpg',
            '/HotSlicePizza_CeasarSalad.jpg',
            '/hot-hawaiian-pizza.jpg',
          ].map((src, index) => (
            <a
              key={index}
              href="https://instagram.com/hotslicepizzasea"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square block overflow-hidden bg-gray-800"
            >
              <img
                src={src}
                alt={`Instagram Feed Image ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              {/* Instagram Hover Overlay */}
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <Instagram className="text-white h-8 w-8 transform scale-50 group-hover:scale-100 transition-transform duration-300" />
              </div>
            </a>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12 sm:mt-16">
          <div className="bg-gradient-to-r from-gray-700 to-gray-600 rounded-3xl p-6 sm:p-8 max-w-2xl mx-auto relative overflow-hidden">
            {/* Decorative gradient */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500"></div>

            <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">
              Taste the Authentic NY Style Experience!
            </h3>
            <p className="text-gray-300 mb-6">
              Every dish is crafted with passion using traditional techniques and the finest halal ingredients.
              Come visit us and experience the flavors of Italy in Seattle.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-4">
              <a
                href="https://instagram.com/hotslicepizzasea"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 hover:from-purple-700 hover:via-pink-700 hover:to-orange-600 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 flex items-center space-x-2 shadow-lg"
              >
                <Instagram className="h-5 w-5" />
                <span>Follow Us</span>
              </a>
              <span className="text-gray-400 text-sm">•</span>
              <span className="text-gray-300 text-sm">See more delicious creations</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageGallery;